

export default {
  props: {
    batchBtnArr: {
      type: Array,
      default: []
    }
  },

  data: function data() {
    return {};
  },


  methods: {
    handleBatchScheduling: function handleBatchScheduling(status, index) {
      // 这里不用对需求状态进行判断
      var statusArr = {
        '交互素材': [],
        '非交互素材': []
      };
      var batchDialogList = this.batchBtnArr[index].batchDialogList;
      for (var i = 0; i < batchDialogList.length; i++) {
        if (batchDialogList[i].type === '交互素材') {
          statusArr['交互素材'].push(batchDialogList[i]);
        } else if (batchDialogList[i].type === '非交互素材') {
          statusArr['非交互素材'].push(batchDialogList[i]);
        }
      }
      if (statusArr['交互素材'].length >= 1 && statusArr['非交互素材'].length >= 1) {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: '\n            \u52FE\u9009\u5185\u5BB9\u975E\u76F8\u540C\u9700\u6C42\u7C7B\u578B\u7684\u7D20\u6750\uFF0C\u65E0\u6CD5' + this.batchBtnArr[index].text + ' <br />\n            <br />\n            <strong>\u4EA4\u4E92\u7D20\u6750ID:</strong> ' + this.everyBtnItemId(statusArr['交互素材']) + ' <br />\n            <br />\n            <strong>\u975E\u4EA4\u4E92\u7D20\u6750ID:</strong> ' + this.everyBtnItemId(statusArr['非交互素材']) + '\n          '
        });
      } else {
        this.$emit('updateData', {
          batchDemandList: batchDialogList,
          batchScheduleDialogConfig: {
            batchDialogType: index,
            visible: true
          }
        });
      }
    },
    everyBtnItemId: function everyBtnItemId(arr) {
      var str = '';
      for (var i = 0; i < arr.length; i++) {
        str += arr[i].id + ' ';
      }
      return str;
    }
  }
};